var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ChipBase,_vm._b({attrs:{"icon":"mdi-account-circle-outline"}},'ChipBase',_vm.$attrs,false),[_vm._v(" "+_vm._s(`Usuario: ${_setup.colaboradorStore?.colaborador?.nome ?? ''}`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }